module.exports = __webpack_public_path__ + "img/2_22.b66960b8.jpg";